<template>
    <g v-if="floor && floorItems" class="layer layer-objects">
        <map-item-point v-for="entry in visibleFloorItems" :key="'item-' + entry.item.index" :item="entry.item" :active="entry.active"
                        :icon-visible="entry.iconVisible" :label-visible="entry.labelVisible" :ghost="entry.ghost"
                        @selected="$emit(`item-selected`, $event)" :nav-enabled="navEnabled" :selected="entry.item === itemSelected"
                        :floor="floor" :ap-stats="apStats" :show-stats="apStats !== null" :range-display="rangeDisplay"/>
    </g>
</template>

<script>
import MapMixin from "@/helpers/maps/map-mixin.js";
import MapItemPoint from "./map-items/map-item-point.vue";

export default {
    name: `layer-map-items`,
    mixins: [MapMixin],
    components: {MapItemPoint},
    inject: [`zoomLevel`],
    props: {
        itemSelected: {type: Object},
        floorItems: {type: Array},
        floor: {type: Object},
        layers: {type: Object},
        navPath: {type: Object},
        rangeDisplay: {type: String, default: `none`},
        apStats: {type: Object, default: null}
    },
    computed: {
        navEnabled() {
            return this.navPath !== null;
        },
        activeItemsSet() {
            if (!this.navPath?.items) return null;
            return new Set(this.navPath.items);
        },
        visibleFloorItems() {
            if (!this.floorItems) {
                return [];
            }

            const isDebug = this.isMapDebugVisible;
            const navEnabled = this.navEnabled;
            const activeSet = this.activeItemsSet;
            const zoomLevel = this.zoomLevel;
            const layers = this.layers;
            const result = [];

            for (const item of this.floorItems) {
                // Layer visibility check
                if (!layers[item.category] && !isDebug) {
                    continue;
                }

                const active = activeSet?.has(item) || false;

                // Show everything for debug
                if (isDebug) {
                    result.push({item, active, iconVisible: true, labelVisible: true});
                    continue;
                }

                // Skip non active items when navigating
                // if (navEnabled && !active && item.visibility !== `always`) {
                //     continue;
                // }

                const selected = item.id === this.itemSelected?.id;

                // Item visibility check
                if (!this.isItemVisible(item, active, selected, zoomLevel)) {
                    continue;
                }

                const iconVisible = item.icon?.visibility !== `never`;
                const labelVisible = this.isLabelVisible(item, active, selected, zoomLevel);

                // Skip items where nothing would render
                if (!iconVisible && !labelVisible) {
                    continue;
                }

                result.push({
                    item,
                    active,
                    iconVisible,
                    labelVisible,
                    ghost: navEnabled && !active && item.visibility !== `always`
                });
            }

            return result;
        }
    },
    methods: {
        isItemVisible(item, active, selected, zoomLevel) {
            if (!active && !selected && item.zoomLevel !== `always` && item.zoomLevel > zoomLevel) {
                return false;
            }
            switch (item.visibility) {
                case `auto`:
                    if (item.type === `door` || item.type === `reception`) {
                        return active;
                    }
                    return item.type !== `nav-point` && item.type !== `qr-code` && item.type !== `directions`;
                case `always`:
                    return true;
                case `active`:
                    return active;
                default:
                    return false;
            }
        },
        isLabelVisible(item, active, selected, zoomLevel) {
            if (!active && !selected && item.zoomLevel !== `always` && item.zoomLevel > zoomLevel - 2) {
                return false;
            }
            switch (item.labelVisibility) {
                case `auto`: {
                    return active || item.category === `location` || item.type === `entrance`;
                }
                case `always`:
                    return true;
                case `active`:
                    return active;
                default:
                    return false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
